<mat-sidenav-container class="main-sidenav-container">
    <mat-sidenav #sidenav role="navigation">
        <app-main-menu (sidenavClose)="sidenav.close()"></app-main-menu>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-header (sidenavToggle)="sidenav.toggle()" [showBackButton]="false" currentTitle=""></app-header>
        <router-outlet class="mdc-typography"></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
